module.exports = __webpack_public_path__ + "assets/img/3e06d0433fb6670cc652d8d0b59f4fb4.png";